module.exports = __webpack_public_path__ + "img/site-map.673b4ba8.svg";